// Dropdown.js
import React, { useContext, useState } from "react";
import { DropdownItem, DropdownMenu } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";

import LogoutIcon from "../../assets/images/logout.svg";
import UserIcon from "../../assets/images/logout-user.svg";
import LogoutPopup from "./LogoutPopup";
import { AdminContext } from "../../context/AdminContext";
import Info from "../../assets/images/user-circle.svg";
import { useNavigate } from "react-router-dom";

const LogoutDropdown = () => {
  const navigate = useNavigate();
  const { username, role } = useContext(AdminContext);
  const [openModal, setOpenModal] = useState(false);

  return (
    <React.Fragment>
      {openModal && (
        <LogoutPopup show={openModal} handleClose={() => setOpenModal(false)} />
      )}
      <div className="logout-main">
        <p className="user-name">{username ? username : "Hello User"}</p>
        <Dropdown>
          <Dropdown.Toggle
            variant="success"
            className="dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img src={UserIcon} alt="user-icon" />
          </Dropdown.Toggle>
          <DropdownMenu
            className="dropdown-menu"
            aria-labelledby="dropdownMenuButton"
          >
            <DropdownItem>
              <h6
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                User Name
              </h6>
              <small
                className="text-muted text-uppercase fw-semibold"
                style={{
                  fontSize: "12px",
                  letterSpacing: "0.5px",
                  position: "relative",
                  bottom: "3px",
                }}
              >
                {username ? username : "Hello User"}
              </small>
            </DropdownItem>
            <DropdownItem>
              <h6
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Role
              </h6>
              <small
                className="text-muted text-uppercase fw-semibold"
                style={{
                  fontSize: "12px",
                  letterSpacing: "0.5px",
                  position: "relative",
                  bottom: "3px",
                }}
              >
                {role?.toString().charAt(0).toUpperCase() +
                  role?.toString().slice(1) || "-"}
              </small>
            </DropdownItem>
            <div className="dropdown-divider"></div>
            <DropdownItem className="p-0">
              <button
                className="dropdown-item d-flex align-items-center py-2 text-muted hover-red"
                onClick={() => navigate("/account/profile")}
                style={{ borderRadius: "6px" }}
              >
                <img src={Info} alt="logout" className="me-2" width="18" />
                <span className="fw-medium">Profile</span>
              </button>
            </DropdownItem>
            <DropdownItem className="p-0">
              <button
                className="dropdown-item d-flex align-items-center py-2 text-danger hover-red"
                onClick={() => setOpenModal(true)}
                style={{ borderRadius: "6px" }}
              >
                <img
                  src={LogoutIcon}
                  alt="logout"
                  className="me-2"
                  width="18"
                />
                <span className="fw-medium">Logout</span>
              </button>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </React.Fragment>
  );
};

export default LogoutDropdown;
